module.exports = __webpack_public_path__ + "static/media/cloudIcon.b3735983.svg";